<template>
  <el-dialog
    :title="$t('Menu.AdministratorInitializationOperationGuidance')"
    :visible="innerVisible"
    append-to-body
    @close="handleClose"
  >
    <ul>
      <li>
        <h4>{{ $t('Menu.ImproveEnterpriseInformation') }}</h4>
        <p>{{ $t('Menu.PleaseImproveYourCompanyEnterpriseInformation') }}，<el-link type="primary" :href="initCompany" target="_blank">{{ $t('Menu.ViewTheSteps') }}</el-link></p>
      </li>
      <li>
        <h4>{{ $t('Menu.CreateAUser') }}</h4>
        <p>{{ $t('Menu.CreateOurUsersAndSetPermissions') }}，<el-link type="primary" :href="initUser" target="_blank">{{ $t('Menu.ViewTheSteps') }}</el-link></p>
      </li>
      <li>
        <h4>{{ $t('Menu.CustomerDataImport') }}</h4>
        <p>{{ $t('Menu.InitializeAndImportTheCompanyOriginalCustomerInformation') }}，<el-link type="primary" :href="initClient" target="_blank">{{ $t('Menu.ViewTheSteps') }}</el-link></p>
      </li>
    </ul>
  </el-dialog>
</template>
<script>
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'InitGuideDialog',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      innerVisible: false,
      initUser: '', // 初始化用户
      initCompany: '', // 初始化本企业
      initClient: ''// 初始化客户
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.initUser = `${cache.config.get('GuidanceInitUser')}?sessionId=${this.user.sessionId}`
      this.initCompany = `${cache.config.get('GuidanceInitCompany')}?sessionId=${this.user.sessionId}`
      this.initClient = `${cache.config.get('GuidanceInitClient')}?sessionId=${this.user.sessionId}`
    },
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
